import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ForbiddenNavigationService } from '@app/routing/services';
import { SearchUrlService } from '@dg/shared-services';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'dgx-forbidden',
    templateUrl: './forbidden.component.html',
    standalone: false
})
export class ForbiddenComponent implements OnInit {
  public backButton: {
    label: string;
    href: string;
  };
  // TODO: when we're no longer a hybrid app, pass a template
  // for the backbutton instead of type + building the button
  // to allow for more flexibility
  @Input() public type: 'pathway' | 'role' | 'plan' | 'org';

  public i18n = this.translate.instant([
    'Pathways_NoAccessHeaderText',
    'Pathways_NoAccessDescriptionText',
    'Pathways_BackButton',
    'Pathways_BackToBrowse',
  ]);

  public badUrl: string | null;
  public readonly CLASS_NAME = 'ForbiddenComponent';

  constructor(
    private navService: ForbiddenNavigationService,
    private activeRoute: ActivatedRoute,
    private translate: TranslateService,
    private searchUrlService: SearchUrlService
  ) {}

  public ngOnInit(): void {
    this.badUrl = this.navService.forbiddenUrl;
    this.backButton = this.getBackButton();
  }

  private getBackButton() {
    // fallback check if we passed the type via the route data
    const type = this.type ?? this.activeRoute.snapshot.data?.type;
    switch (type) {
      case 'pathway':
        return {
          href: this.searchUrlService.getGlobalSearchURL({
            filters: 'Type:pathway',
          }),
          label: this.i18n.Pathways_BackButton,
        };
      case 'org':
        return null;
      case 'plan':
      case 'role':
      default:
        return {
          href: this.searchUrlService.getGlobalSearchURL(),
          label: this.i18n.Pathways_BackToBrowse,
        };
    }
  }
}
